import { LivedataServerData, LockType } from '@lk/api'
import includes from 'lodash/includes'

import { WILDCARD_USER_ID } from './livedata.constants'

export const delayedAction = (action, timeoutMs) => (dispatch) => {
  setTimeout(() => {
    dispatch(action)
  }, timeoutMs)
}

export const isUserLockedByOther = (liveData: LivedataServerData, userID: number) =>
  liveData.OpenDayStatus.Locked === LockType.Locked &&
  !includes([WILDCARD_USER_ID, liveData.OpenDayStatus.SEC_UserID], userID)
